import router from '@/router'

export default {
  state: {
    nomination: [],
    detailedNomination: []
  },
  mutations: {
    setNomination (state, payload) {
      state.nomination = payload
    },
    setDetailedNomination (state, payload) {
      state.detailedNomination = payload
    }
  },
  actions: {
    async setNomination (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/nominations`)
      res = await res.json()
      this.commit('setNomination', await res)
    },

    async setDetailedNomination (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/nominations/${payload}`)
      res = await res.json()
      this.commit('setDetailedNomination', await res)
    },

    async deleteNomination (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/nominations/${payload}`, {
        method: 'DELETE',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }).then(res => {
        if (res.status === 200) {
          ctx.commit('setMessage', {
            type: 'success',
            text: 'Номинация успешно удален'
          })
        } else {
          ctx.commit('setMessage', { type: 'error', text: 'Ошибка удаления' })
        }
        ctx.dispatch('setNomination')
      })
        .catch(error => console.log('error', error))
    },

    async createNomination (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/nominations`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload
      })
        .then(res => {
          if (res.status === 201) {
            router.push('/admin/nomination')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Создание номинации прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка создания'
            })
          }
        })
        .catch(error => console.log('error', error))
    },

    async editNomination (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/nominations/${payload.id}`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload.data
      })
        .then(res => {
          if (res.status === 200) {
            router.push('/admin/nomination')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Изменение номинации прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка создания'
            })
          }
        })
        .catch(error => console.log('error', error))
    }
  },
  getters: {
    getNomination: (s) => s.nomination,
    getDetailedNomination: (s) => s.detailedNomination
  }
}
